<template>
  <div class="card chart-card borderless-card">
    <div class="card-header card-padding-zero" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <div class="tabulator" ref="table"></div>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
import Card from "./Card.vue";
import util from "util";
import _ from "lodash";
export default {
  name: "tabulator-card",
  components: {
    Card
  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tableColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tableOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    tableData: {
      handler: function(nData) {
        if (this.tabulator) this.tabulator.replaceData(nData);
      }
    },
    tableColumns: {
      handler(ndata) {
        if (this.tabulator) {
          this.tabulator.setColumns(ndata);
          // replace the tabulator
          // this.tabulator = new Tabulator.default(this.$refs.table, _.merge({}, this.tableOptions, { data: this.tableData, columns: ndata }));
        }
      }
    }
  },
  data() {
    return {
      tabulator: null
    };
  },
  async mounted() {
    let Tabulator = await import("tabulator-tables");
    this.tabulator = new Tabulator.default(
      this.$refs.table,
      _.merge({}, this.tableOptions, {
        data: this.tableData,
        columns: this.tableColumns
      })
    );
    this.$emit("tabulatorDetails", this.tabulator);
  }
};
</script>
<style>
#theMainTableBoxInvestments
  .tabulator
  > .tabulator-tableHolder
  > .tabulator-table
  > .tabulator-row
  > .tabulator-cell.link {
  color: #5445f3;
  text-decoration: underline;
  cursor: pointer;
}
.card-padding-zero {
  padding-top: 0px !important;
  padding-left: 30px !important;
  padding-right: 30px !important;
}
</style>